import { collection, query, where, getDocs } from 'firebase/firestore';
import { db, collections } from '@/lib/firebase';
import { Evaluator } from '@/types/evaluator';

export async function getEvaluatorsForUser(userId: string): Promise<Evaluator[]> {
  const evaluatorsRef = collection(db, collections.evaluators);
  const q = query(evaluatorsRef, where('userId', '==', userId));
  const snapshot = await getDocs(q);
  
  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  })) as Evaluator[];
}